import React from "react";
import { Route, Routes, HashRouter } from "react-router-dom";
import { Render } from './functions/index'


function AppRouter() {
  return (
    <>
      <HashRouter>
        <Routes>
          <Route exact path="/" element={<Render type={1} key={window.location.href} />} />

          <Route path="/user-info" name="user-info" element={<Render type={2} key={window.location.href} />} />

          <Route path="/authentication" name="authentication" element={<Render type={3} key={window.location.href} />} />

          <Route path="/services" name="services" element={<Render type={4} key={window.location.href} />} />

          <Route path="/lines" name="lines" element={<Render type={5} key={window.location.href} />} />

          <Route path="/lines-list" name="lines-list" element={<Render type={6} key={window.location.href} />} />

          <Route path="/transaction" name="transaction" element={<Render type={7} key={window.location.href} />} />

          <Route path="/promotions" name="promotions" element={<Render type={8} key={window.location.href} />} />

          <Route path="/promotion" name="promotion" element={<Render type={9} key={window.location.href} />} />

          <Route path="/setting" name="setting" element={<Render type={10} key={window.location.href} />} />

          <Route path="/changeEmailList" name="changeEmailList" element={<Render type={11} key={window.location.href} />} />

          <Route path="/invoicelList" name="invoicelList" element={<Render type={12} key={window.location.href} />} />

          <Route path="/invoiceOfUser" name="invoiceOfUser" element={<Render type={13} key={window.location.href} />} />

          <Route path="/output" name="output" element={<Render type={14} key={window.location.href} />} />

          <Route path="/activities" name="activities" element={<Render type={15} key={window.location.href} />} />
          <Route path="/calendar" name="calendar" element={<Render type={17} key={window.location.href} />} />
          <Route path="/activePackage" name="activePackage" element={<Render type={18} key={window.location.href} />} />




        </Routes>
      </HashRouter>
    </>



  );
}
export default AppRouter;
//    <Route path="/authentication" name="authentication" element={<UserInfo />} type=3/>
//    <Route exact path="/">
//    <Render type={1} key={window.location.href} />
//  </Route>
//  <Route path="/user-info">
//    <Render type={2} key={window.location.href} />
//  </Route>
//  <Route path="/authentication">
//    <Render type={3} key={window.location.href} />
//  </Route>
//  <Route path="/services">
//    <Render type={4} key={window.location.href} />
//  </Route>
//  <Route exact path="/lines">
//    <Render type={5} key={window.location.href} />
//  </Route>
//  <Route path="/lines-list">
//    <Render type={6} key={window.location.href} />
//  </Route>
//  <Route path="/transaction">
//    <Render type={7} key={window.location.href} />
//  </Route>
//  <Route path="/promotions">
//    <Render type={8} key={window.location.href} />
//  </Route>
//  <Route path="/promotion">
//    <Render type={9} key={window.location.href} />
//  </Route>
//  <Route path="/setting">
//    <Render type={10} key={window.location.href} />
//  </Route>
//  <Route path="/changeEmailList">
//    <Render type={11} key={window.location.href} />
//  </Route>